import PropTypes from "prop-types";
import { useContext, useEffect } from "react";
import { logoutUser } from "app/pages/Auth/AuthActions";
import Quotation from "./Quotation";
import {
	checkAvailibilities,
	fetchFlightOptions,
	preBook,
	saveQuotationSearchQueryString,
	showFlexRatesModal,
} from "app/pages/Booking/Quotation/quotationActionCreators";
import { updateBooking } from "app/pages/Booking/bookingActionCreators";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { bookingPropTypes, quotationPropTypes } from "app/utils/propTypes.js";
import {
	getIncludedFlight,
	getQuotationPriceChangeData,
	getTransfersOfSelectedFlight,
	getVisibleFlights,
} from "app/pages/Booking/Quotation/quotationSelectors.js";
import cloneDeep from "lodash/cloneDeep";
import { clearPromotionValue } from "app/pages/Booking/PromotionCode/promotionCodeActionCreators";
import withRouter from "app/utils/hocs/withRouter";
import isEmpty from "lodash/isEmpty";
import {
	buildQuotationReloadUrl,
	extractQuotationPayloadFromQueryParams,
} from "app/utils/urlDataExtractor";
import { withAlert } from "app/pages/.shared/Alert/AlertContainer.jsx";
import { injectIntl } from "react-intl";
import { getStore } from "app/configureStore";
import {
	pushTagQuotationSubmit,
	sendTagDepositOnQuotePage,
	sendTagOnFlightOptionsFail,
	sendTagOnQuotationFail,
	sendTagOnQuotationPageLoad,
	sendTagOnQuotationResult,
} from "app/utils/analytics";
import {
	HTTP_STATUS_CODES,
	INSURANCE_STANDARD,
	OFFER_TYPES,
	PASSENGER_TYPE,
	QUOTATION_CODE_STATUS,
	QUOTATION_SESSION_EXPIRED_TIMEOUT,
	QUOTATION_STATUS_VALIDE,
	STRATEGY,
} from "app/constants";
import {
	calculatePreBookTotal,
	isBookingEligibleForDeposit,
	getFlightOptionsOfSelectedFlight,
} from "app/pages/Booking/bookingSelectors";
import get from "lodash/get";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import {
	finishLoadingBar,
	showLoadingBar,
} from "app/pages/.shared/LoadingBar/loadingBarActionCreators";
import { parseQueries } from "app/utils/routerUtils";
import { saveNavLog } from "app/pages/Listing/NavLogs/navLogActionCreators";
import { fetchFicheProduit } from "app/pages/Listing/productActionCreators";
import { checkIfNavlogEnabled } from "app/pages/Listing/NavLogs/navLogsSelector";
import { checkSpecialOfferOnQuote } from "app/pages/Booking/Payment/paymentSelector";
import { getSpecialOffer } from "app/pages/FicheProduit/ficheProduitSelector";
import {
	computeActivitiesDuplicateDates,
	handleFailPreBookResponse,
	handleSuccesPreBookResponse,
} from "app/utils/quotationUtils";
import { checkSDPAvailibilities, clearSmartDP } from "app/pages/SmartDP/smartDPActionCreators";
import { getFallbackRedirectUrl } from "app/reducers/partnerSelector";
import {
	hasOptionFlex,
	shouldEnableFlexRateChoice,
} from "app/pages/Booking/Quotation/flexSelectors";
import { getSessionBiid } from "app/pages/Auth/authSelectors";
import { hasEmptyParams } from "app/utils/utils.url";
import { FSSdkStatus, useFlagship, useFsFlag } from "@flagship.io/react-sdk";
import AppGlobalsContext from "app/AppGlobalsContext";
import usePrevious from "app/utils/hooks/usePrevious";
import { isServerSide } from "app/utils/utils";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import withFlagship from "app/utils/hocs/withFlagship";
import { getCredentials } from "app/utils/auth";
import { useLocation } from "react-router-dom";
import {
	checkStopoverAvailibilities,
	fetchStopoverFlightOptions,
} from "app/pages/Stopover/stopoverActionCreators";
import { Formik } from "formik";
import { updateExchangeRate } from "app/reducers/exchangeRateActionCreators";

const QuotationContainer = props => {
	const {
		updateBooking,
		sessionBiid,
		finishLoadingBar,
		formInitialValues,
		clearPromotionValue,
		location = {},
		partnerCode,
		strategy,
		booking,
		ficheProduit,
		navigate,
		fetchFicheProduit,
		showFlexRatesModal,
		quotation,
		checkAvailibilities = () => {},
		fetchFlightOptions = () => {},
		fetchStopoverFlightOptions = () => {},
		intl,
		showAlert,
		isNavlogsEnabled,
		isBookingEligibleForDeposit,
		checkSDPAvailibilities,
		checkStopoverAvailibilities,
		smartDPCode,
		selectedflightCode,
		fallbackRedirectUrl,
		token,
		logoutUser,
		saveQuotationSearchQueryString,
		showLoadingBar,
		preBook,
		abTestsValues,
		updateExchangeRate,
	} = props;

	const ppFunnelFlags = useFsFlag("pp_funnel_flags");
	const ppFunnelFlagsValues = ppFunnelFlags.getValue(undefined);
	const { sdkStatus } = useFlagship();
	const isFlagshipSDKReady = sdkStatus === FSSdkStatus?.SDK_INITIALIZED;
	const previousFsIsSdkReadyStatus = usePrevious(isFlagshipSDKReady);
	const { brand, shop } = useContext(AppGlobalsContext);

	const { pathname } = useLocation();

	const isSDPQuote = pathname?.includes("/sdp/booking/quote");

	const isStopoverQuote = pathname?.includes("/stopover/booking/quote");

	const { track } = useAnalytics();

	useEffect(() => {
		let timeoutID;
		if (!isSDPQuote && !isStopoverQuote) {
			timeoutID = setTimeout(() => {
				const alertTitle = intl.formatMessage({
					id: `quotation.alert.session.expired.title`,
				});
				const alertMessage = intl.formatMessage({
					id: `quotation.alert.session.expired.message`,
				});

				const alertActionNodes = [
					<Button
						variant={BUTTON_VARIANTS.FILLED}
						size={BUTTON_SIZES.LARGE}
						key="quotation.alert.session.expired.button.label"
						label={intl.formatMessage({
							id: `quotation.alert.session.expired.button.label`,
						})}
					/>,
				];

				const onConfirm = () => {
					window.location.reload();
				};

				// clear previous quotation url to be sure that /quote is called
				saveQuotationSearchQueryString("");

				showAlert({ alertTitle, alertMessage, alertActionNodes, onConfirm });

				track("quotation_session_expired_timeout");
			}, QUOTATION_SESSION_EXPIRED_TIMEOUT);
		}

		return () => {
			if (timeoutID) {
				clearTimeout(timeoutID);
			}
		};
	}, []);

	const buildBookingUpdatedData = (quotationFromQuery = {}) => {
		const passengers = [];

		for (let i = 0; i < quotationFromQuery?.adults; i++) {
			passengers.push({
				type: PASSENGER_TYPE.ADULT,
				index: i + 1,
			});
		}

		for (let i = 0; i < quotationFromQuery?.children; i++) {
			passengers.push({
				type: PASSENGER_TYPE.CHILD,
				index: i + 1,
				birthdate: quotationFromQuery?.childrenBirthdates
					? quotationFromQuery?.childrenBirthdates[i]
					: {},
			});
		}

		for (let i = 0; i < quotationFromQuery?.infants; i++) {
			passengers.push({
				type: PASSENGER_TYPE.INFANT,
				index: i + 1,
				birthdate: quotationFromQuery?.infantsBirthdates
					? quotationFromQuery?.infantsBirthdates[i]
					: {},
			});
		}

		return {
			offer: {
				label: quotationFromQuery?.offerLabel,
				type: quotationFromQuery?.offerType,
				contractType: quotationFromQuery?.contractType,
				negotiated: quotationFromQuery?.negotiated || [],
			},
			departureCity: {
				code: quotationFromQuery?.departureCityCode,
				label: quotationFromQuery?.departureCityLabel,
			},
			rentalAccommodation: {
				accommodation: quotationFromQuery?.accommodationLabel,
			},
			departureDate: quotationFromQuery?.departureDate,
			endDate: quotationFromQuery?.endDate,
			duration: { value: quotationFromQuery?.duration },
			adults: quotationFromQuery?.adults || 0,
			children: quotationFromQuery?.children || 0,
			infants: quotationFromQuery?.infants || 0,
			passengers: passengers,
			price: quotationFromQuery?.price,
		};
	};

	const updateBookingFromQueryPayload = quotationFromQuery => {
		updateBooking(buildBookingUpdatedData(quotationFromQuery));
	};

	const buildQuotationPayload = quotationPayload => {
		// cloneDeep au lieu de Object.assign pour eviter de modifier le childrenBirthdatesdu payload source
		const quotationPayloadCopy = cloneDeep(quotationPayload);

		if (sessionBiid) {
			quotationPayloadCopy.sessionBiid = sessionBiid;
		}

		// On incremente le mois car le service attend 1 pour janvier par exemple
		const childrenBirthdates = quotationPayloadCopy.childrenBirthdates
			? quotationPayloadCopy.childrenBirthdates.map(birthdate => {
					birthdate.month = birthdate.month + 1;
					return birthdate;
			  })
			: [];

		const infantsBirthdates = quotationPayloadCopy.infantsBirthdates
			? quotationPayloadCopy.infantsBirthdates.map(birthdate => {
					birthdate.month = birthdate.month + 1;
					return birthdate;
			  })
			: [];

		quotationPayloadCopy.childrenBirthdates = childrenBirthdates;
		quotationPayloadCopy.infantsBirthdates = infantsBirthdates;

		return quotationPayloadCopy;
	};

	useEffect(() => {
		clearPromotionValue({ promoCode: "", code: quotation.code });

		const query = parseQueries(location.search);

		if (
			(!isServerSide && window.Cypress) ||
			(isFlagshipSDKReady &&
				previousFsIsSdkReadyStatus !== isFlagshipSDKReady &&
				(!ppFunnelFlags.exists() || !isEmpty(ppFunnelFlagsValues)))
		) {
			if (isSDPQuote) {
				const { accommodationId, boardCode, price = 0 } = query;

				// do not fetch availibilities again if already fetched (quotation.code is not undefined)
				// quotation.code is reset when we clicked on a sdp product (look for clearQuotation() usage)
				// fetch availabilities will reset accommodations and boards codes => user selection can not be persisted
				if (!quotation.code) {
					checkSDPAvailibilities({
						code: location.state?.code || smartDPCode,
						accommodationId,
						boardCode,
						price: Number(price),
						abTests: ppFunnelFlagsValues,
					}).then(response => {
						sendTagOnQuotationResult(response);

						const flights = response.data?.flights || [];

						if (flights?.length > 0) {
							fetchFlightOptions({
								flight: flights[0].code,
								code: response?.data.code,
								accommodationId,
							}).then(response => {
								const flightOptionsHttpStatus = response.status;

								if (
									!flightOptionsHttpStatus ||
									flightOptionsHttpStatus ===
										HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR ||
									flightOptionsHttpStatus === HTTP_STATUS_CODES.GATEWAY_TIMEOUT ||
									flightOptionsHttpStatus === HTTP_STATUS_CODES.BAD_REQUEST ||
									flightOptionsHttpStatus === HTTP_STATUS_CODES.FORBIDDEN
								) {
									sendTagOnFlightOptionsFail();
								}
							});
						}
					});
				}
			} else if (isStopoverQuote) {
				const { accommodationId, boardCode, price = 0, stopoverDuration } = query;

				// do not fetch availibilities again if already fetched (quotation.code is not undefined)
				// quotation.code is reset when we clicked on a sdp product (look for clearQuotation() usage)
				// fetch availabilities will reset accommodations and boards codes => user selection can not be persisted
				if (!quotation.code) {
					checkStopoverAvailibilities({
						bookingFlowId: location.state?.code || smartDPCode,
						accommodationId,
						boardCode,
						price: Number(price),
						abTests: ppFunnelFlagsValues,
						stopoverDuration: stopoverDuration,
					}).then(response => {
						sendTagOnQuotationResult(response);

						// get flight code from store as is it already selected in the stopover listing page
						fetchStopoverFlightOptions({
							flight: selectedflightCode,
							bookingFlowId: response?.data?.bookingFlowId,
							accommodationId,
							stopOverDuration: Number(stopoverDuration),
						}).then(response => {
							const flightOptionsHttpStatus = response.status;

							if (
								!flightOptionsHttpStatus ||
								flightOptionsHttpStatus ===
									HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR ||
								flightOptionsHttpStatus === HTTP_STATUS_CODES.GATEWAY_TIMEOUT ||
								flightOptionsHttpStatus === HTTP_STATUS_CODES.BAD_REQUEST ||
								flightOptionsHttpStatus === HTTP_STATUS_CODES.FORBIDDEN
							) {
								sendTagOnFlightOptionsFail();
							}
						});
					});
				}
			} else {
				// Ici on est dans le cas d'une quotation PP (/booking/quote)

				const quotationFromQuery = extractQuotationPayloadFromQueryParams(query);

				if (!quotationFromQuery || isEmpty(quotationFromQuery)) {
					// si on arrive ici, c'est qu'on a chargé la page quotation directement sans passer par le tunnel de resa

					if (fallbackRedirectUrl.indexOf("https") !== -1) {
						window.location = fallbackRedirectUrl;
					} else {
						// hack to fix "You should call navigate() in a React.useEffect(), not when your component is first rendered"
						// may be deleted when moving this component to functional
						setTimeout(() => {
							navigate({ pathname: fallbackRedirectUrl });
						}, 100);
					}
				}

				const productUri = query.productUri || ficheProduit.uri;

				/**
				 * we need to call fetchFicheProduit before checkAvailibilities because checkAvailibilities needs config in payload that depends
				 * on the product json and offerType in qoutation url.
				 */
				fetchFicheProduit({ productUri }).then(res => {
					// do not fetch availibilities again if already fetched (quotation.code is not undefined)
					// quotation.code is reset when we clicked on a product (look for clearQuotation() usage)
					// fetch availabilities will reset accommodations and boards codes => user selection can not be persisted

					if (res?.status !== HTTP_STATUS_CODES.OK) {
						track("fetch_product_json_fail", {
							productUri: productUri,
							httpStatus: res?.status,
						});

						navigate(
							{
								pathname: "/technical-error",
							},
							{
								replace: true,
							}
						); // replace pour éviter un back navigateur sur la page de quotation
					} else if (res?.data?.endAt && res?.data?.endAt - new Date().getTime() <= 0) {
						navigate({ pathname: `/${productUri}` }, { replace: true });
					} else if (!quotation.code || quotation.searchQueryString !== location.search) {
						/**
						 * the config, mandatory in the quotation payload, is no more fetched from the quotation url but
						 * is fetch from the product json using productUri and the offerType from quotation url.
						 */
						const selectedOfferData = res.data?.offers?.find(
							offer => offer?.pricing?.type === quotationFromQuery.offerType
						);

						const { departureCities = [], alternativeDepartureCities = [] } =
							selectedOfferData?.pricing || {};

						let departureCityLabel;
						if (
							quotationFromQuery.offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION
						) {
							departureCityLabel = [
								...departureCities,
								...alternativeDepartureCities,
							].find(city => city.code === quotationFromQuery.departureCityCode)
								?.label;
						}

						const productId = res?.data?.id;

						if (!isEmpty(quotationFromQuery)) {
							updateBookingFromQueryPayload({
								...quotationFromQuery,
								config: selectedOfferData?.pricing?.config,
								offerLabel: selectedOfferData?.pricing?.label,
								contractType: selectedOfferData?.pricing?.contractType,
								negotiated: selectedOfferData?.negotiated,
								departureCityLabel,
							});
						}

						checkAvailibilities(
							buildQuotationPayload({
								...quotationFromQuery,
								config: selectedOfferData?.pricing?.config,
								productId,
								partnerCode,
								abTests: ppFunnelFlagsValues,
							})
						).then(response => {
							updateExchangeRate({
								usd: response?.data?.exchangeRateUSD,
							});
							saveQuotationSearchQueryString(location.search);

							const quoteURL = `${window.location.protocol}//${
								window.location.host
							}/${shop}/booking/quote`;

							const quotationReloadURL = buildQuotationReloadUrl(quoteURL, {
								booking: {
									...booking,
									...buildBookingUpdatedData(quotationFromQuery),
								},
								ficheProduit: res.data, // take the response of fetchFicheProduit instead of the store. It will be up to date
							});

							sendTagOnQuotationPageLoad(quotationReloadURL);
							sendTagOnQuotationResult(response);

							const isQuotationFull = [
								QUOTATION_CODE_STATUS.MISSING_INCLUDED_ACTIVITY,
								QUOTATION_CODE_STATUS.FULL_FLIGHT,
								QUOTATION_CODE_STATUS.FULL_PROPERTY,
								QUOTATION_CODE_STATUS.FULL_TRANSFER,
							].includes(get(response, "data.status"));

							const quoteHttpStatus = response.status;
							const httpErrorMessage = get(response, "data.message");

							if (
								!quoteHttpStatus ||
								quoteHttpStatus === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR ||
								quoteHttpStatus === HTTP_STATUS_CODES.GATEWAY_TIMEOUT ||
								quoteHttpStatus === HTTP_STATUS_CODES.BAD_REQUEST
							) {
								sendTagOnQuotationFail(quoteHttpStatus);
								navigate(
									{
										pathname: "/technical-error",
									},
									{
										replace: true,
										state: {
											errorMessage: httpErrorMessage,
										},
									}
								); // replace pour éviter un back navigateur sur la page de quotation
							} else if (quoteHttpStatus === HTTP_STATUS_CODES.FORBIDDEN) {
								sendTagOnQuotationFail(quoteHttpStatus);

								if (strategy === STRATEGY.OAUTH) {
									navigate({ pathname: "/technical-error/sso" });
								} else if (strategy === STRATEGY.TRANSACTION_FIRST) {
									if (token) {
										logoutUser(shop);
										window.location = `${window.location.protocol}//${
											window.location.host
										}${window.location.pathname}${window.location.search}`;
									} else {
										navigate(
											{
												pathname: "/technical-error",
											},
											{
												replace: true,
												state: {
													errorMessage: httpErrorMessage,
												},
											}
										);
									}
								} else {
									const onauthsuccess = encodeURIComponent(
										`${location.pathname}${location.search}`
									);

									navigate(
										{
											pathname: "/booking/auth",
											search: `?onauthsuccess=${onauthsuccess}`,
										},
										{ replace: true }
									); // replace pour éviter un back navigateur sur la page de quotation
								}
							} else if (
								quoteHttpStatus === HTTP_STATUS_CODES.OK &&
								isQuotationFull
							) {
								navigate("/booking/search", {
									replace: true,
									state: {
										alertMessageId: "error.no.availabilities.search",
									},
								});
							} else if (
								quoteHttpStatus === HTTP_STATUS_CODES.OK &&
								QUOTATION_STATUS_VALIDE.includes(get(response, "data.status"))
							) {
								// TOUT EST OK
								if (isNavlogsEnabled && !hasEmptyParams(quotationReloadURL)) {
									// dans le cas où on arrive d'une quotationURL
									// et qu'on fetch le produit sur une page /quote
									saveNavLog({
										product: {
											id: res?.data?.id,
										},
										quotationURL: quotationReloadURL,
									});
								}

								const flights = response.data?.flights || [];

								if (flights?.length > 0) {
									fetchFlightOptions({
										flight: flights[0].code,
										code: response?.data.code,
									}).then(response => {
										const flightOptionsHttpStatus = response.status;

										if (
											!flightOptionsHttpStatus ||
											flightOptionsHttpStatus ===
												HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR ||
											flightOptionsHttpStatus ===
												HTTP_STATUS_CODES.GATEWAY_TIMEOUT ||
											flightOptionsHttpStatus ===
												HTTP_STATUS_CODES.BAD_REQUEST ||
											flightOptionsHttpStatus === HTTP_STATUS_CODES.FORBIDDEN
										) {
											sendTagOnFlightOptionsFail();
										}
									});
								}
							} else {
								// here we got a 200 but with a code other than SUCCESS

								sendTagOnQuotationFail(quoteHttpStatus);
								navigate(
									{
										pathname: "/technical-error",
									},
									{
										replace: true,
										state: {
											errorMessage: httpErrorMessage,
										},
									}
								); // replace pour éviter un back navigateur sur la page de quotation
							}
						});
					}
				});
			}
		}

		if (isBookingEligibleForDeposit) {
			sendTagDepositOnQuotePage();
		}

		return () => {
			finishLoadingBar();
			showFlexRatesModal(false);
		};
	}, [
		location.search,
		isFlagshipSDKReady,
		previousFsIsSdkReadyStatus,
		ppFunnelFlagsValues,
		brand,
	]);

	const handleSubmit = async values => {
		pushTagQuotationSubmit();
		showLoadingBar();

		const payload = mapFormToPayload(values, { abTestsValues, location });
		const response = await preBook(payload);

		if (response?.status === HTTP_STATUS_CODES.OK) {
			handleSuccesPreBookResponse(response, navigate, false, location);
		} else {
			handleFailPreBookResponse(response, navigate, strategy, location);
		}

		finishLoadingBar();
	};

	const handleValidation = () => {
		const errors = {};

		const duplicateDates = computeActivitiesDuplicateDates(booking?.activities);

		if (duplicateDates?.length > 0) {
			errors.duplicateDates = duplicateDates;
		}

		return errors;
	};

	return (
		<Formik
			initialValues={formInitialValues}
			onSubmit={handleSubmit}
			enableReinitialize
			validateOnChange={false}
			validateOnBlur={false}
			validate={handleValidation}
		>
			<Quotation {...props} isStopover={isStopoverQuote} />
		</Formik>
	);
};

QuotationContainer.propTypes = {
	checkAvailibilities: PropTypes.func,
	checkSDPAvailibilities: PropTypes.func,
	checkStopoverAvailibilities: PropTypes.func,
	clearPromotionValue: PropTypes.func,
	fetchFicheProduit: PropTypes.func,
	fetchFlightOptions: PropTypes.func,
	fetchStopoverFlightOptions: PropTypes.func,
	finishLoadingBar: PropTypes.func,
	logoutUser: PropTypes.func,
	navigate: PropTypes.func,
	preBook: PropTypes.func,
	saveQuotationSearchQueryString: PropTypes.func,
	showAlert: PropTypes.func,
	showFlexRatesModal: PropTypes.func,
	showLoadingBar: PropTypes.func,
	updateBooking: PropTypes.func,

	location: PropTypes.shape({
		pathname: PropTypes.string,
		search: PropTypes.string,
		state: PropTypes.object,
	}),

	booking: bookingPropTypes,
	quotation: quotationPropTypes,

	abTestsValues: PropTypes.object,
	fallbackRedirectUrl: PropTypes.string,
	ficheProduit: PropTypes.object,
	formInitialValues: PropTypes.object,
	intl: PropTypes.object,
	isBookingEligibleForDeposit: PropTypes.bool,
	isNavlogsEnabled: PropTypes.bool,
	partnerCode: PropTypes.string,
	selectedflightCode: PropTypes.string,
	sessionBiid: PropTypes.string,
	smartDPCode: PropTypes.string,
	strategy: PropTypes.string,
	token: PropTypes.string,
	updateExchangeRate: PropTypes.func,
};

// getBaggagePayload returns the payload for the luggage or cabin luggage from the form values, even though they might be the same we don't want to pass unnecessary fields.
const getBaggagePayload = formBaggage => {
	if (!formBaggage.quantity) {
		return null;
	}

	const payload = {
		quantity: formBaggage.quantity,
	};

	if (formBaggage.code) {
		payload.code = formBaggage.code;
	}

	if (formBaggage.maxWeightPerBaggage) {
		payload.maxWeightPerBaggage = formBaggage.maxWeightPerBaggage;
	}

	return payload;
};

const mapFormToPayload = (values, ownProps) => {
	const state = getStore().getState();

	const booking = state.booking;
	let newPayload = {
		code: state.quotation.code,
		accommodationBoardCode: values.board,
		flight: values.flight,
		transfer: values.transfer,
		totalPrice: calculatePreBookTotal(state),
		abTests: ownProps.abTestsValues,
	};

	const isStopover = ownProps.location?.pathname?.includes("/stopover/booking/quote");
	if (isStopover) {
		newPayload.bookingFlowId = state.quotation.code;
		delete newPayload.code;
		newPayload.stopOverDuration = state.booking?.stopoverDuration;
	}

	newPayload.flightOptions = {
		flightBagageOption: {},
	};

	const flightOptionsOfSelectedFlight = getFlightOptionsOfSelectedFlight(state) || {};
	if (
		flightOptionsOfSelectedFlight.flightBagageOption &&
		!flightOptionsOfSelectedFlight.flightBagageOption?.included &&
		values.luggage?.quantity > 0
	) {
		newPayload.flightOptions.flightBagageOption.holdBaggage = getBaggagePayload(values.luggage);
	}

	if (values.cabinLuggage.quantity > 0) {
		newPayload.flightOptions.flightBagageOption.cabinBaggage = getBaggagePayload(
			values.cabinLuggage
		);
	}

	if (booking.activities.length > 0) {
		newPayload.activities = booking.activities.filter(activity => {
			activity.guests = activity.guests.filter(guest => {
				return guest.guestsCount > 0;
			});

			return activity.guests.length > 0 ? activity : false;
		});
	}

	if (booking.insuranceFlex) {
		const { code } = booking.insuranceFlex;
		newPayload.flexInsuranceCode = code !== INSURANCE_STANDARD ? code : null;
	}

	return newPayload;
};

const mapStateToProps = state => {
	const includedFlight = getIncludedFlight(state);
	const flights = getVisibleFlights(state);
	const booking = state.booking;
	const activities = state.quotation.activities;

	const formInitialValues = {
		accommodation: !isEmpty(booking.accommodation) ? booking.accommodation.code : undefined,
		flight: !isEmpty(booking.flight) ? booking.flight.code : undefined,
		board: !isEmpty(booking.board) ? booking.board.code : undefined,
		transfer: !isEmpty(booking.transfer) ? booking.transfer.code : undefined,
		activities: activities.map(activity => {
			const activityDate =
				booking?.activities?.find(act => act?.code === activity?.code)?.date ||
				activity?.suggestedDate;

			return {
				code: activity?.code,
				date: activityDate,
				guests: activity?.guestsPerDay?.[activityDate]?.reduce((acc, guest) => {
					const nbOfGuests =
						booking?.activities
							?.find(act => act?.code === activity?.code)
							?.guests?.find(g => g.code === guest.code)?.guestsCount ||
						guest.includedGuest;

					acc[guest.code] = nbOfGuests;
					return acc;
				}, {}),
			};
		}),
		luggage: booking.luggage,
		cabinLuggage: booking.cabinLuggage,
	};

	const enableFlexRateChoice = shouldEnableFlexRateChoice(state);

	const { token } = getCredentials(state.shop);

	return {
		transfers: getTransfersOfSelectedFlight(state),
		booking,
		selectedflightCode: booking.flight?.code,
		strategy: state.partner.strategy,
		quotation: state.quotation,
		isBookingEligibleForDeposit: isBookingEligibleForDeposit(state),
		flights: flights,
		includedFlight,
		partnerCode: state.partner.code,
		sessionBiid: getSessionBiid(state),
		formInitialValues,
		ficheProduit: state.ficheProduit,
		resolution: state.resolution,
		searchQueryString: state.smartDP.searchQueryString,
		isNavlogsEnabled: checkIfNavlogEnabled(state),
		hasSpecialOfferOnQuote: checkSpecialOfferOnQuote(state),
		specialOffer: getSpecialOffer(state),
		enableFlexRateChoice,
		smartDPCode: state.smartDP.code,
		prePackageOffers: state.prePackageOffer.offers,
		fallbackRedirectUrl: getFallbackRedirectUrl(state),
		isOptionFlexAvailable: hasOptionFlex(state),
		token: token,
		ficheProduitStatus: state.ficheProduit.status,
		priceChangeData: getQuotationPriceChangeData(state),
		flightLuggageOption: getFlightOptionsOfSelectedFlight(state)?.flightBagageOption,
	};
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			checkStopoverAvailibilities,
			checkSDPAvailibilities,
			checkAvailibilities,
			updateBooking,
			clearPromotionValue,
			showLoadingBar,
			finishLoadingBar,
			saveNavLog,
			fetchFicheProduit,
			showFlexRatesModal,
			logoutUser,
			saveQuotationSearchQueryString,
			clearSmartDP,
			fetchFlightOptions,
			fetchStopoverFlightOptions,
			preBook,
			updateExchangeRate,
		},
		dispatch
	);

export default injectIntl(
	withRouter(
		withFlagship(
			withAlert(
				connect(
					mapStateToProps,
					mapDispatchToProps
				)(QuotationContainer)
			)
		)
	)
);
